// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Element from 'element-ui'

import TWEEN from 'tween'
import App from './App'
import { router } from './router'
import store from './store'
import filters from './filters'
import axios from 'axios'
import 'animate.css'
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/diy.scss'
import '@/styles/common.scss'
import '@/styles/transition.scss'
import '@/styles/tailwind.min.css'

import './assets/iconfont/iconfont.css'
Vue.prototype.$tween = TWEEN
Vue.use(Element)
Vue.config.productionTip = false
Vue.prototype.$axios = axios

Object.keys(filters).forEach(k => Vue.filter(k, filters[k]))
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js